var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-4",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('organizations-list',{attrs:{"selected-id":_vm.selectedOrg ? _vm.selectedOrg.id : null},on:{"select":_vm.selectOrganization}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('organization-panel',{attrs:{"org":_vm.selectedOrg}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }